import { Reveal, CtaLink } from "./primitives";

export const CtaBand = ({
  title = "Let's Build a Healthier, More Connected India.",
  body = "We are looking for healthcare partners, community organisations, mentors, incubators and early investors who want to help validate and shape this model.",
  primary = { to: "/partners#enquiry", label: "Partner With Us" },
  secondary = { to: "/contact", label: "Contact SwastSaathi" },
  testId = "cta-band",
}) => (
  <section data-testid={testId} className="bg-white py-20 lg:py-28">
    <div className="container-x">
      <Reveal className="grain relative overflow-hidden rounded-[2rem] bg-plum px-7 py-14 sm:px-12 lg:px-16 lg:py-20">
        <img src="/logo-mark.png" alt="" aria-hidden="true" className="pointer-events-none absolute -right-16 -top-10 w-[340px] opacity-[0.12] lg:w-[460px]" />
        <div className="relative max-w-2xl">
          <span className="inline-block h-1 w-10 rounded-full bg-magenta" />
          <h2 className="mt-6 text-3xl font-semibold leading-[1.1] text-white sm:text-4xl lg:text-5xl">{title}</h2>
          <p className="mt-5 text-base leading-relaxed text-white/75 md:text-lg">{body}</p>
          <div className="mt-9 flex flex-wrap gap-3">
            <CtaLink to={primary.to} testId={`${testId}-primary`} variant="primary">{primary.label}</CtaLink>
            <CtaLink to={secondary.to} testId={`${testId}-secondary`} variant="ghostLight">{secondary.label}</CtaLink>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
